import Vue from 'vue';
import VueDaumPostcode from 'vue-daum-postcode';

Vue.use(VueDaumPostcode);
